module.exports = __webpack_public_path__ + "img/6.28a4e362.png";